import { Container, Sprite, Text, TextStyle, Texture } from "pixi.js";
import { GameFont } from "../GameFont";
import { HBox } from "./ui/HBox";

export class BonusPercentContainer extends Container {
    public constructor(icon: Texture, percentValue: number) {
        super();
        const hBox = new HBox(10);
        this.addChild(hBox);
        const rewardValueText = new Text(`+${percentValue}%`, new PercentTextStyle());
        rewardValueText.position.y = 10;
        hBox.addChild(rewardValueText);
        const rewardIcon = new Sprite(icon);
        hBox.addChild(rewardIcon);
        hBox.x = -hBox.getLocalBounds().width * 0.5;
    }
}

class PercentTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fill: "#ffffff",
            align: "center",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 108
        }));
    }
}
